var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialogis-wrapper"},[_c('inn-confirm-dialog',{ref:"confirm"}),_c('inn-loading-dialog',{ref:"loading"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }